import { Routes } from "@/config/routes";
import { observer } from "mobx-react-lite";
import { FormWrapper } from "@/components/forms/FormWrapper";
import { FormInput } from "@/components/forms/FormInput";
import { useTranslation } from "react-i18next";
import { Card, CardContent } from "@/components/ui/card";
import { AuthenticationFormHeader } from "@/components/forms/AuthenticationFormHeader";
import { useResetPassword } from "./useResetPassword";
import { AuthenticationFormFooter } from "@/components/forms/AuthenticationFormFooter";
import { FormSubmitButton } from "@/components/forms/FormSubmitButton";

export const ResetPassword = observer(() => {
	const { t } = useTranslation();
	const { form, onSubmit, loading, showForm, error } = useResetPassword();

	return (
		<Card>
			<AuthenticationFormHeader
				title={showForm ? t("pages.reset_password.title") : t("pages.reset_password.success_titel")}
				description={
					showForm ? t("pages.reset_password.expalantion") : t("pages.reset_password.success_explanation")
				}
			/>

			{showForm && (
				<CardContent>
					<FormWrapper form={form} onSubmit={onSubmit} error={error}>
						<FormInput
							required
							name="password"
							type="password"
							label={t("shared.forms.password.label")}
							placeholder={t("shared.forms.password.placeholder")}
						/>
						<FormInput
							required
							name="confirmPassword"
							type="password"
							label={t("pages.reset_password.repet_password_label")}
							placeholder={t("shared.forms.password.placeholder")}
						/>

						<FormSubmitButton
							isLoading={loading}
							buttonText={t("pages.reset_password.button_text")}
							buttonLoadingText={t("pages.reset_password.loading_button_text")}
						/>
					</FormWrapper>
				</CardContent>
			)}

			<AuthenticationFormFooter
				content={t("pages.reset_password.remember_password_text")}
				link={{ linkText: t("pages.reset_password.login_button_text"), linkTo: Routes.Auth.Login.path }}
			/>
		</Card>
	);
});
